import { WEBSITE_UUID_RE } from '@dukanti/shared';

/** Epic #228 P3: the template library, reached with "Change template". */
export const TEMPLATE_LIBRARY_PATH = '/storefront/templates';

const TEMPLATE_EDIT_PATH_RE =
  /^\/storefront\/templates\/([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12})\/edit$/;

/** True for a template id the edit route accepts. */
export function isTemplateId(value: string | undefined): value is string {
  return typeof value === 'string' && WEBSITE_UUID_RE.test(value);
}

/** The edit route of one template: `/storefront/templates/:templateId/edit`. */
export function templateEditPath(templateId: string): string {
  return `${TEMPLATE_LIBRARY_PATH}/${templateId}/edit`;
}

/** True for exactly an edit-route pathname with a real template id; nothing else. */
export function isTemplateEditPath(pathname: string): boolean {
  return TEMPLATE_EDIT_PATH_RE.test(pathname);
}

/**
 * Why the edit route sent the merchant to the library. Carried in the router
 * location state, never in the address.
 *
 * - `template-unavailable`: the template cannot be opened (not an id,
 *   unknown, not this store's).
 * - `not-started`: the template has no saved draft; visiting its address does
 *   not start it, "Use template" does.
 */
export type TemplateLibraryNotice = 'template-unavailable' | 'not-started';
const TEMPLATE_LIBRARY_NOTICES: readonly TemplateLibraryNotice[] = [
  'template-unavailable',
  'not-started',
];

export interface TemplateLibraryLocationState {
  readonly notice?: TemplateLibraryNotice;
}

/** The notice of a library location state, or null. Anything unexpected is ignored. */
export function templateLibraryNotice(state: unknown): TemplateLibraryNotice | null {
  if (typeof state !== 'object' || state === null) return null;
  const notice = (state as { readonly notice?: unknown }).notice;
  return TEMPLATE_LIBRARY_NOTICES.find((known) => known === notice) ?? null;
}
